import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("telesales-jobs")!;

export const Route = createFileRoute("/telesales-jobs")({
  head: () => pageHead("/telesales-jobs"),
  component: () => <CategoryPage category={category} />,
});
